import React from 'react'
import { connect } from 'react-redux'
import { ProtocolListWithHeader, protocolListPropTypes, protocolListDefaultProps, useBreadcrumb } from 'components'
import {
  deleteProtocol,
  loadRecentProtocols,
  loadProtocolTypes
} from 'reduxModules/protocols'
import {
  getProtocolsToDisplay,
  getUsedProtocolTypes
} from 'reduxModules/protocols/selectors'

const breadcrumbLevels = [
  { text: 'Dashboard' },
  { text: 'Recent' }
]

export const RecentProtocols = ({
  protocolsToDisplay,
  onDeleteClick,
  types,
  sendingProtocol,
  loading,
  onMount
}) => {
  useBreadcrumb(breadcrumbLevels)

  return (
    <ProtocolListWithHeader
      loading={loading}
      types={types}
      onDeleteClick={onDeleteClick}
      sendingProtocol={sendingProtocol}
      protocolsToDisplay={protocolsToDisplay}
      headingTitle='Recent Protocols'
      onMount={onMount}
    />
  )
}

RecentProtocols.propTypes = protocolListPropTypes
RecentProtocols.defaultProps = protocolListDefaultProps

const mapStateToProps = (state) => ({
  protocolsToDisplay: getProtocolsToDisplay(state),
  types: getUsedProtocolTypes(state),
  loading: state.protocols.loading,
  sendingProtocol: state.protocols.sendingProtocol
})

const mapDispatchToProps = (dispatch) => ({
  onDeleteClick: (id) => {
    dispatch(deleteProtocol(id))
  },
  onMount: async () => {
    await dispatch(loadRecentProtocols())
    dispatch(loadProtocolTypes())
  }
})

export default connect(
  mapStateToProps, mapDispatchToProps
)(RecentProtocols)
